module.exports = __webpack_public_path__ + "media/images/checkout/challenger/phone-0fbda5b4e7a9db8e9f0b1716a6bb2f3e.svg";